<template>
  <div class="slice skeleton" style="height: 100vh">&nbsp;</div>
</template>

<script>
export default {
  name: 'LoadingSlice',
}
</script>
